export const FreightOptions = {
  DEFAULT: 0,
  SEDEX: 1,
};